import VCalendar from 'v-calendar'
import type { UserPlugin } from '~/types'
import 'v-calendar/dist/style.css'

export const install: UserPlugin = ({ app }) => {
  app.use(VCalendar, {})
}
